export const convertToBrakes = (text = ''): string => {
  return text.split('\n').join('<br>');
};
